import React from 'react';
import { OverflowMenuItem as Component } from '@vfuk/core-overflow-menu';
const OverflowMenuItem = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default OverflowMenuItem;
